import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: "root"
})
export class DownloadService {
    constructor(private http: HttpClient) { }

    // Download by URL, will attempt to query the name/type from the download
    public DownloadUrl(url: string, defaultFileName: string = "download", defaultFileType: string = "text/html"): Promise<void> {
        return new Promise<void>(async res => {
            //var jwtToken = this.authSvc.GetToken();
            const h = new HttpHeaders({
                //Authorization: `Bearer ${jwtToken}`
            });
            // https://stackoverflow.com/questions/54753021/how-can-i-pass-an-auth-token-when-downloading-a-file
            // the below code 'works' for now... doesn't allow us to show status or abort... and may have issues with 
            // popup blockers... 
            const response = await this.http.get(url, { headers: h, responseType: 'blob', observe: 'response' }).toPromise();
            if (response.body) {
                var fileName: string = defaultFileName;
                var contentDisposition = response.headers.get("Content-Disposition");
                if (contentDisposition) {
                    // REGEX /.+filename=["]?([^"]*)["]?;.*/ GRAB filename= skip if no quote everything but quote, next quote if exists, semi column and everything else
                    //"attachment; filename="Marsha Test Document 123.docx"; filename*=UTF-8''Marsha%20Test%20Document%20123.docx"
                    //"attachment; filename=Test.docx; filename*=UTF-8''Test.docx"
                    var found = contentDisposition.match(/.+filename=["]?([^"]*)["]?;.*/);
                    if (found && found.length > 1) {
                        fileName = found[1];
                    }
                }

                var fileType: string = defaultFileType;
                var contentType = response.headers.get("Content-Type");
                if (contentType && contentType.length > 0) fileType = contentType;

                this.Download(response.body, fileType, fileName).then(() => {
                    res();
                })
            }
            else {
                console.error('error on download');
                res();
            }
        });
    }

    // Download assumes you have either a base64 string or blob object
    public Download(data: Blob | string, fileType: string, fileName: string): Promise<void> {
        if (data instanceof Blob)
            return this.blobDownload(data, fileType, fileName);

        return this.base64Download(data, fileType, fileName);
    }

    private blobDownload(blob: Blob, fileType: string, fileName: string): Promise<void> {
        return new Promise<void>(async res => {
            //remove this stuff 13 bytes + the types --- data:image/png;base64,
            var buffer = await blob.arrayBuffer();
            var byteArray = new Uint8Array(buffer);
            var file = new File([byteArray], fileName, { type: fileType });

            this.download(file).then(() => {
                res();
            });
        })
    }

    // public GetFileFromFileObject(fileObject: FileObject): File {
    //     return this.GetFile(fileObject.data, fileObject.type, fileObject.name);
    // }
    public GetFile(base64Content: string, fileType: string, fileName: string): File {
        //remove this stuff 13 bytes + the types --- data:image/png;base64,
        var data = base64Content;
        if (data.startsWith("data:")) {
            const BASE64TYPEDATALENGTH = 13; // 13 is everything but the type:  data:image/png;base64,
            data = data.substring(fileType.length + BASE64TYPEDATALENGTH);
        }
        var byteCharacters = atob(data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        //var file = new Blob([byteArray], { type: this.formControl.value.type });
        var file = new File([byteArray], fileName, { type: fileType });
        return file;
    }

    private base64Download(base64Content: string, fileType: string, fileName: string): Promise<void> {
        return new Promise<void>(res => {
            var file = this.GetFile(base64Content, fileType, fileName);

            this.download(file).then(() => {
                res();
            });
        })
    }

    private download(file: File): Promise<void> {
        return new Promise<void>(res => {
            var fileUrl = URL.createObjectURL(file);

            const anchor = document.createElement('a');
            anchor.href = fileUrl;
            // Get the suggested filename for the file from the response headers
            anchor.download = file.name;
            //
            document.body.appendChild(anchor);
            // Simulate a click on our anchor element
            anchor.click();

            setTimeout(() => {
                // Discard the object data
                URL.revokeObjectURL(fileUrl);
                document.body.removeChild(anchor);
                res();
            }, 2000);
        })
    }
}